import { useFormikContext } from 'formik';

import { Box } from '@hivebrite/design-system/Box';
import { PillsList } from '@hivebrite/design-system/PillsList';

import {
  type AIFormWidgetFormValues,
  type SmartSuggestion,
} from 'hb-react/shared/components/AIFormWidget/types';

interface SmartSuggestionsProps {
  smartSuggestions?: Array<SmartSuggestion>;
}

export const SmartSuggestions = ({
  smartSuggestions,
}: SmartSuggestionsProps) => {
  const { setFieldValue } = useFormikContext<AIFormWidgetFormValues>();

  if (!smartSuggestions || smartSuggestions.length === 0) {
    return null;
  }

  const pills = smartSuggestions.map((suggestion, id) => ({
    id,
    name: suggestion.title,
    onClick: () => {
      setFieldValue('aiPrompt', suggestion.prompt);
    },
  }));

  return (
    <Box
      position="absolute"
      left={3}
      bottom={3}
      zIndex={10}
      maxWidth="400px"
      flexDirection="column"
      gridRowGap={2}
    >
      <Box font="footnote-asphalt" color="asphalt">
        {s__('AIForm|Smart suggestions')}
      </Box>
      <PillsList
        pills={pills}
        limit={8}
        seeMoreLabel={s__('AIForm|See more')}
        seeLessLabel={s__('AIForm|See less')}
      />
    </Box>
  );
};
